const IMAGE_BASE =
  'https://static.gettyimages.com/site-merchandising/site-media/';

// Placeholder until Site Merchandising supplies the destinations.
const PLACEHOLDER_HREF = '#';

export type EditorialDefaultTile = {
  id: string;
  href: string;
  imageSrc: string;
  labelKey: string;
  headingKey: string;
};

// The tiles Site Merchandising set for the Editorial landing pages, shown when
// Workbench has none to show.
export type EditorialDefaultTilesConfig = {
  // Keyed by the editorial landing page name Workbench content is targeted at.
  byPage: Readonly<Record<string, ReadonlyArray<EditorialDefaultTile>>>;
  // Shown on a page with no set of its own.
  otherPages: ReadonlyArray<EditorialDefaultTile>;
};

const gettyAllEditorialTiles: ReadonlyArray<EditorialDefaultTile> = [
  {
    id: 'all_sports_photos',
    href: PLACEHOLDER_HREF,
    imageSrc: `${IMAGE_BASE}GojT2JIoPtHP_Editorial%20Fallback%20Tiles_All_01.png`,
    labelKey: 'editorial_default_tile_tag_sports',
    headingKey: 'editorial_default_tile_top_sports_photos',
  },
  {
    id: 'all_news_photos',
    href: PLACEHOLDER_HREF,
    imageSrc: `${IMAGE_BASE}iiGijgTbT89l_Editorial%20Fallback%20Tiles_All_02.png`,
    labelKey: 'editorial_default_tile_tag_news',
    headingKey: 'editorial_default_tile_top_news_photos',
  },
];

export const gettyEditorialDefaultTiles: EditorialDefaultTilesConfig = {
  byPage: {
    editorial_browse_all: gettyAllEditorialTiles,
    editorial_browse_news: [
      {
        id: 'news_photos',
        href: PLACEHOLDER_HREF,
        imageSrc: `${IMAGE_BASE}1S6FfYs8plBr_Editorial%20Fallback%20Tiles_News_01.png`,
        labelKey: 'editorial_default_tile_tag_news',
        headingKey: 'editorial_default_tile_top_news_photos',
      },
      {
        id: 'news_videos',
        href: PLACEHOLDER_HREF,
        imageSrc: `${IMAGE_BASE}ihOUDohRSj9n_Editorial%20Fallback%20Tiles_News_02.png`,
        labelKey: 'editorial_default_tile_tag_news',
        headingKey: 'editorial_default_tile_top_news_videos',
      },
    ],
    editorial_browse_sport: [
      {
        id: 'sports_photos',
        href: PLACEHOLDER_HREF,
        imageSrc: `${IMAGE_BASE}IAfukRhpgAgL_Editorial%20Fallback%20Tiles_Sports_01.png`,
        labelKey: 'editorial_default_tile_tag_sports',
        headingKey: 'editorial_default_tile_top_sports_photos',
      },
      {
        id: 'sports_videos',
        href: PLACEHOLDER_HREF,
        imageSrc: `${IMAGE_BASE}gElzV20s8Z4e_Editorial%20Fallback%20Tiles_Sports_02.png`,
        labelKey: 'editorial_default_tile_tag_sports',
        headingKey: 'editorial_default_tile_top_sports_videos',
      },
    ],
    editorial_browse_entertainment: [
      {
        id: 'contour_portraits',
        href: PLACEHOLDER_HREF,
        imageSrc: `${IMAGE_BASE}CbR7GxzdBDte_Editorial%20Fallback%20Tiles_Entertainment_01.png`,
        labelKey: 'editorial_default_tile_tag_entertainment',
        headingKey: 'editorial_default_tile_contour_portraits',
      },
      {
        id: 'assignments',
        href: PLACEHOLDER_HREF,
        imageSrc: `${IMAGE_BASE}KqPX3enFuhOm_Editorial%20Fallback%20Tiles_Entertainment_02.png`,
        labelKey: 'editorial_default_tile_tag_entertainment',
        headingKey: 'editorial_default_tile_assignments',
      },
    ],
    editorial_browse_archival: [
      {
        id: 'discover_archives',
        href: PLACEHOLDER_HREF,
        imageSrc: `${IMAGE_BASE}fDj2XdCujnVI_Editorial%20Fallback%20Tiles_Archival_01.png`,
        labelKey: 'editorial_default_tile_tag_archive',
        headingKey: 'editorial_default_tile_discover_archives',
      },
      {
        id: 'plan_ahead',
        href: PLACEHOLDER_HREF,
        imageSrc: `${IMAGE_BASE}adQbVyXBmBQ5_Editorial%20Fallback%20Tiles_Archival_02.png`,
        labelKey: 'editorial_default_tile_tag_archive',
        headingKey: 'editorial_default_tile_plan_ahead',
      },
    ],
  },
  otherPages: gettyAllEditorialTiles,
};

// iStock has no Editorial landing pages.
export const iStockEditorialDefaultTiles: EditorialDefaultTilesConfig = {
  byPage: {},
  otherPages: [],
};
